<template lang="pug">
.content
  .gridcontainer
    .round1
      .info(v-if="round1.games[0].players[0]")
        img(:src="round1.games[0].players[0].character")
        label {{round1.games[0].players[0].name}}
        span {{round1.games[0].score1}}
    .round1
      .info(v-if="round1.games[0].players[1]")
        img(:src="round1.games[0].players[1].character")
        label {{round1.games[0].players[1].name}}
        span {{round1.games[0].score2}}
    .medwhite
    .round1
      .info(v-if="round1.games[1].players[0]")
        img(:src="round1.games[1].players[0].character")
        label {{round1.games[1].players[0].name}}
        span {{round1.games[1].score1}}
    .round1
      .info(v-if="round1.games[1].players[1]")
        img(:src="round1.games[1].players[1].character")
        label {{round1.games[1].players[1].name}}
        span {{round1.games[1].score2}}
    .white
    .white
    .white.special
    .white
    .white
    .white
    .white
    .white.rightOnly
    .white.topOnly
    .white

    .white
    .white
    .white
    .white.topOnly
    .white
    .white
    .white
    .white.topOnly
    .white
    .white

    .round1
      .info(v-if="round2.games[0].players[1]")
        img(:src="round2.games[0].players[1].character")
        label {{round2.games[0].players[1].name}}
        span {{round2.games[0].score2}}
    .round1
      .info(v-if="round2.games[0].players[0]")
        img(:src="round2.games[0].players[0].character")
        label {{round2.games[0].players[0].name}}
        span {{round2.games[0].score1}}
    .medwhite
    .round1
      .info(v-if="round2.games[1].players[0]")
        img(:src="round2.games[1].players[0].character")
        label {{round2.games[1].players[0].name}}
        span {{round2.games[1].score1}}
    .round1
      .info(v-if="round2.games[1].players[1]")
        img(:src="round2.games[1].players[1].character")
        label {{round2.games[1].players[1].name}}
        span {{round2.games[1].score2}}
    .white
    .white
    .white.special
    .white.rightOnly
    .white
    .white
    .white.rightOnly
    .white.rightOnly
    .white.topOnly
    .white

    .white
    .white
    .white
    .white
    .white.topOnly
    .white
    .white.topOnly
    .white
    .white
    .white

    .medwhite
    .white
    .round1
      .info(v-if="round3.games[0].players[0]")
        img(:src="round3.games[0].players[0].character")
        label {{round3.games[0].players[0].name}}
        span {{round3.games[0].score1}}
    .round1
      .info(v-if="round3.games[0].players[1]")
        img(:src="round3.games[0].players[1].character")
        label {{round3.games[0].players[1].name}}
        span {{round3.games[0].score2}}
    .white
    .medwhite

    .white
    .white
    .white
    .white
    .white
    .white.special
    .white
    .white
    .white
    .white

    .white
    .white
    .white
    .white
    .white
    .white
    .white.topOnly
    .white
    .white
    .white

    .medwhite
    .white
    .round1
      .info(v-if="round4.games[0].players[0]")
        img(:src="round4.games[0].players[0].character")
        label {{round4.games[0].players[0].name}}
        span {{round4.games[0].score1}}
    .round1
      .info(v-if="round4.games[0].players[1]")
        img(:src="round4.games[0].players[1].character")
        label {{round4.games[0].players[1].name}}
        span {{round4.games[0].score2}}
    .white
    .medwhite

</template>
<script>
import Event from '../event.js';
export default {
  name: "LoserBracketComponent",
  data : function() {
    return this.loserState();
  },
  methods: {
    resetComponent() {
      Object.assign(this.$data, this.loserState());
    },
    loserState() {
      return {
        round1: {
          games: [{players: [], score1: undefined, score2: undefined}, {players: [], score1: undefined, score2: undefined}],
          points: 100
        },
        round2: {
          games: [{players: [], score1: undefined, score2: undefined}, {players: [], score1: undefined, score2: undefined}],
          points: 100
        },
        round3: {
          games: [{players: [], score1: undefined, score2: undefined}],
          points: 100
        },
        round4: {
          games: [{players: [], score1: undefined, score2: undefined}],
          points: 100
        },
        bracketWinner: undefined,
        gameStatus: 'round1'
      }
    },
    addPlayer(player) {
      console.log(this.gameStatus);
      if(this.gameStatus == 'round1'){
        this.round1.games.filter(lambda => lambda.players.length !== 2)[0].players.push(player);
      }else if(this.gameStatus == 'round2'){
        this.round2.games.filter(lambda => lambda.players.length !== 2)[0].players.push(player);
      } else if(this.gameStatus == 'round3'){
        this.round4.games[0].players.push(player);
      } else if(this.gameStatus == 'round4'){
        this.round4.games[0].players.push(player);
      }
    },
    endGameFirstRound(first, second) {
      let toPlay = this.round1.games.filter((game) => typeof game.score1 === 'undefined' && typeof game.score2 === 'undefined');
      console.log(toPlay);
      let game = toPlay[0];
      game.score1 = first;
      game.score2 = second;
      this.round2.games.some((spel) => {
        if(spel.players.length < 1) {
          let result = this.findResult(game);
          spel.players.push(result[0]);
          return true;
        }
      });
      if(toPlay.length === 1) {
        this.gameStatus = 'round2';
      }
      this.findNextGame();
    },
    endGameSecondRound(first, second) {
      let toPlay = this.round2.games.filter((game) => typeof game.score1 === 'undefined' && typeof game.score2 === 'undefined');
      let game = toPlay[0];
      game.score1 = first;
      game.score2 = second;
      let spel = this.round3.games[0];
      if(spel.players.length < 2) {
        let result = this.findResult(game);
        spel.players.push(result[0]);
        if(spel.players.length == 2) {
          this.gameStatus = 'round3';
        }
      } else {
        console.log('something went wrong');
      }
      this.findNextGame();
    },
    endGameThirdRound(first, second) {
      let game = this.round3.games[0];
      let spel = this.round4.games[0];
      game.score1 = first;
      game.score2 = second;
      if(spel.players.length < 2) {
        let result = this.findResult(game);
        spel.players.push(result[0]);
        if(spel.players.length == 2) {
          this.gameStatus = 'round4';
        }
      } else {
        console.log('something went wrong');
      }
      this.findNextGame();
    },
    endGameFourthRound(first, second) {
      let game = this.round4.games[0];
      game.score1 = first;
      game.score2 = second;
      let result = this.findResult(game);
      this.bracketWinner = result[0];
      Event.$emit('To Winnerbracket', this.bracketWinner);
      Event.$emit('third', result[1]);
    },
    findResult(game) {
      if(game.score1 > game.score2) {
        return [game.players[0], game.players[1]];
      } else {
        return [game.players[1], game.players[0]];
      }
    },
    findNextGame() {
      let game;
      if(this.gameStatus == 'round1') {
        game = this.round1.games.filter((game) => typeof game.score1 === 'undefined' && typeof game.score2 === 'undefined')[0];
      } else if(this.gameStatus == 'round2') {
        game = this.round2.games.filter((game) => typeof game.score1 === 'undefined' && typeof game.score2 === 'undefined')[0];
      } else if(this.gameStatus == 'round3') {
        game = this.round3.games[0];
      } else if(this.gameStatus == 'round4') {
        game = this.round4.games[0];
      }
      Event.$emit('Next losergame', game);
    },
  },
  mounted() {
    this.findNextGame();
    Event.$on('To Loserbracket', (player) => {
      this.addPlayer(player);
    });
    Event.$on('reset', () => {
      this.resetComponent();
      this.findNextGame();
    });
    Event.$on('submitScore', (first, second, turn) => {
      console.log('triggered');
      console.log(turn);
      if(turn === 'l'){
        if(this.gameStatus == 'round1') {
          this.endGameFirstRound(first, second);
        }
        else if(this.gameStatus == 'round2') {
          this.endGameSecondRound(first, second);
        } else if(this.gameStatus == 'round3') {
          this.endGameThirdRound(first, second);
        } else if (this.gameStatus == 'round4') {
          this.endGameFourthRound(first, second);
        }
      }
    });
  }
}
</script>

<style lang="scss" scoped>
  .gridcontainer{
    display: grid;
    grid-template-columns: 20% 3% 3% 20% 3% 3% 20% 3% 3% 20%;
    grid-template-rows: repeat(10, 10%);
    grid-auto-flow: column;
    // background-color: lightblue;
    padding: 10px;
    width: 90%;
    height: 200px;
    margin-left: 5%;
    //margin-right: 10%;

    .round1{
      text-align: center;
      font-size: 30px;
      grid-row: span 2;
      border: 1px solid black;
      background: linear-gradient(to right, #9F1002, #000000);
      .info{
        background: linear-gradient(to right, #9F1002, #1E0906);
        height: 100%;
      }
      .won{
          background-color: darkgreen;
        }
      img{
        height: 100%;
        float: left;
      }
      label{
        font-size: 30px;
        vertical-align: center;
      }
      button{
        float: right;
        vertical-align: center;
        height: 100%;
        font-size: 30px;
        background-color: transparent;
        color: white;
        padding: 5px;
      }
      button:disabled, button[disabled]{
        background-color: gray;
      }
      button:hover:enabled{
          background-color: indigo;
          cursor: pointer;
        }
    }

    /*.bracket{
      height: 50px;
      width: 200px;
      margin-left: 30px;
      margin-right: 30px;
    }*/

    .white{
      // border: 1px solid gray;
      background: transparent;
    }
    .special{
        border-top: 2px solid blue;
        border-right: 2px solid blue;
        background: transparent;
      }
    .rightOnly{
      border-right: 2px solid blue;
    }
    .topOnly{
      border-top: 2px solid blue;
    }
    .bigwhite{
      border: 1px solid black;
      background: transparent;
      grid-row: span 4;
    }
    .medwhite{
      border: 1px solid black;
      background: transparent;
      grid-row: span 2;
    }
  }

  span {
    float: right;
    background: #4c0000;
    color: white;
    margin-top: 1px;
    margin-bottom: 1px;
    padding-left: 5px;
    padding-right: 5px;
    font-size: 28px;
    border-radius: 25px;
  }

</style>
